<div>
    <div class="desktop">
        <div class="box-container">
            <div class="m-3 center">
                <div class="row">
                    <div class="col-3">
                        <div class="p-2 clickable" [routerLink]="['/']">
                            <img class="logo-img" src="../../../assets/img/logo_go_contratos.png">
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="row">
                            <div class="col text-center">
                                <div class="pt-3 nowrap">
                                    <p class="header-item"><a href="https://gocontratos.com.br/o-software" target=”_blank”>{{i18n.HOME.THE_SOFTWARE}}</a></p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3">
                                    <p class="header-item"><a href="https://gocontratos.com.br/precos" target=”_blank”>{{i18n.HOME.PRICE}}</a></p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3 clickable nowrap">
                                    <p class="header-item"><a href="https://gocontratos.com.br/conteudo-2" target=”_blank”>{{i18n.HOME.CONTENT}}</a>&nbsp;&nbsp;<i class="fas fa-chevron-down blue"></i></p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3 clickable nowrap">
                                    <p class="header-item"><a href="https://gocontratos.com.br/sobre-nos" target=”_blank”>{{i18n.HOME.ABOUT}}</a>&nbsp;&nbsp;<i class="fas fa-chevron-down blue"></i></p>
                                </div>
                            </div>
                            <div class="col text-center">
                                <div class="pt-3">
                                    <p class="header-item"><a href="https://gocontratos.com.br/contato" target=”_blank”>{{i18n.HOME.CONTACT}}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="button-blue-desk d-flex justify-content-center align-items-center">
                            <p class="header-item"><a href="https://signer-qa.gocontratos.com">{{i18n.HOME.ACCESS_ACCOUNT}}</a></p>
                        </div>
                    </div>
                    <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="box-shadow-flag f-12-rb p-2 text-center clickable">
                                <div *ngIf="language == 'pt_BR'" (click)="setLanguage('en_US')">
                                    <span class="ml-1">{{i18n.HOME.CHANGE_LANGUAGE}}</span>&nbsp;&nbsp;<img
                                        src="../../../assets/img/arrow_down.png" />
                                    <img class="pl-2" src="../../../assets/img/flag_brazil.png" />
                                </div>
                                <div *ngIf="language == 'en_US'" (click)="setLanguage('pt_BR')">
                                    <span class="ml-1">{{i18n.HOME.CHANGE_LANGUAGE}}</span>&nbsp;&nbsp;<img
                                        src="../../../assets/img/arrow_down.png" />
                                    <img class="pl-2" src="../../../assets/img/flag_usa.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div>
            <div class="box-content">
                <div class="row mr-0">
                    <div class="col-6">
                        <div>
                            <div class="p-5 mt-1">
                                <div class="p-4 mt-2 white">
                                    <p class="mb-0 ml-2 pl-5 text-title bold ">{{i18n.HOME.TEST_14_FREE}}</p>
                                    <p class="pl-2 f-16-os ml-5">{{i18n.HOME.NO_NEED_CREDIT_CARD}}</p>
                                </div>
                                <div class="ml-5 pt-1 pl-4">
                                    <p class="pl-2 f-40-os text-content lighter white">{{i18n.HOME.CHOICE_RIGHT}}</p>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="box-content-data">
                            <div class="p-4 ml-4 text-center">
                                <p class="mt-4 f-40-rb lighter blue-dark">{{i18n.HOME.REGISTER}}</p>
                                <div class="mt-4">
                                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.name == null}">
                                        <i class="f-20 ml-1 mr-2 icon-person gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i><input id="name" type="text" [(ngModel)]="register.name" placeholder="{{i18n.HOME.COMPLETE_NAME}}" />
                                    </div>
                                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.email == null}">
                                        <i class="f-20  ml-2 fas fa-envelope gray-light">&nbsp;&nbsp;</i><input id="email" type="text" [(ngModel)]="register.email" placeholder="{{i18n.HOME.CORPORATIVE_EMAIL}}"  />
                                    </div>
                                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.username == null}">
                                        <i class="f-20 ml-2 mr-1 fas fa-user gray-light">&nbsp;&nbsp;</i><input id="username" type="text" [(ngModel)]="register.username" placeholder="{{i18n.HOME.USER_NAME}}"  />
                                    </div>
                                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.password == null}">
                                        <i class="f-20  ml-2 mr-1 fas fas fa-lock-alt gray-light">&nbsp;&nbsp;</i><input id="password" type="password" [(ngModel)]="register.password" placeholder="{{i18n.HOME.PASSWORD}}"  />
                                    </div>
                                    <!--div class="box-input mt-3" [ngClass]="{'box-input-error': register.company == null}">
                                        <i class="f-20  ml-1 mr-2 fas icon-company gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i><input id="company" type="text" [(ngModel)]="register.company" placeholder="{{i18n.HOME.COMPANY_NAME}}"  />
                                    </div>
                                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.companyDocument == null}">
                                        <i class="f-20 ml-1 mr-2 fas icon-doc-company gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i>
                                        <input id="companyDocument" type="text" onkeypress="return /[0-9]/i.test(event.key)" [(ngModel)]="register.companyDocument" placeholder="{{i18n.HOME.COMPANY_DOCUMENT}}" value="{{register.companyDocument | cpfCnpj}}" maxlength="17" />
                                    </div-->
                                    <div class="button-blue mt-4 clickable" (click)="registerUser()">
                                        <div class="pt-2">
                                            <p class="white pt-2 f-14-rb">{{i18n.HOME.CREATE}}</p>
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <div class="text-center mt-1 clickable" [routerLink]="[ '/']">
                                            <p class="f-11-os gray">{{i18n.HOME.HAVE_ACCOUNT}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="mobile">
        <div class="m-2">
            <div class="row">
                <div class="col">
                    <div class="pl-2 pt-2">
                        <i class="f-26 icon-bars">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
                    </div>
                </div>
                <div class="col right">
                    <div class="d-flex flex-row-reverse">
                        <div class="box-shadow-flag p-2">
                            <div *ngIf="language == 'pt_BR'" (click)="setLanguage('en_US')">
                                <img src="../../../assets/img/arrow_down.png" />
                                <img class="pl-2" src="../../../assets/img/flag_brazil.png" />
                            </div>
                            <div *ngIf="language == 'en_US'" (click)="setLanguage('pt_BR')">
                                <img src="../../../assets/img/arrow_down.png" />
                                <img class="pl-2" src="../../../assets/img/flag_usa.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="box-content white">
            <div class="pt-4 p-2">
                <p class="mb-0 f-28-os bold text-center">{{i18n.HOME.TEST_14_FREE}}</p>
                <p class="f-11-os ml-4">{{i18n.HOME.NO_NEED_CREDIT_CARD}}</p>
            </div>
            <div class="p-2">
                <p class="f-15-os lighter text-center">{{i18n.HOME.CHOICE_RIGHT}}</p>
            </div>
        </div>
        <div class="box-content-data m-4">
            <div class="p-4 text-center">
                <p class="f-20-rb lighter blue-dark">{{i18n.HOME.REGISTER}}</p>
                <div class="mt-3">
                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.name == null}">
                        <i class="ml-1 mr-2 icon-person gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i><input id="name" type="text" [(ngModel)]="register.name" placeholder="{{i18n.HOME.COMPLETE_NAME}}" />
                    </div>
                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.email == null}">
                        <i class="ml-2 fas fa-envelope gray-light">&nbsp;&nbsp;</i><input id="email" type="text" [(ngModel)]="register.email" placeholder="{{i18n.HOME.CORPORATIVE_EMAIL}}"  />
                    </div>
                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.username == null}">
                        <i class="ml-2 mr-1 fas fa-user gray-light">&nbsp;&nbsp;</i><input id="username" type="text" [(ngModel)]="register.username" placeholder="{{i18n.HOME.USER_NAME}}"  />
                    </div>
                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.password == null}">
                        <i class="ml-2 mr-1 fas fas fa-lock-alt gray-light">&nbsp;&nbsp;</i><input id="password" type="password" [(ngModel)]="register.password" placeholder="{{i18n.HOME.PASSWORD}}"  />
                    </div>
                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.company == null}">
                        <i class="ml-1 mr-2 fas icon-company gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i><input id="company" type="text" [(ngModel)]="register.company" placeholder="{{i18n.HOME.COMPANY_NAME}}"  />
                    </div>
                    <div class="box-input mt-3" [ngClass]="{'box-input-error': register.companyDocument == null}">
                        <i class="ml-1 mr-2 fas icon-doc-company gray-light">&nbsp;&nbsp;&nbsp;&nbsp;</i>
                        <input id="companyDocument" type="text" onkeypress="return /[0-9]/i.test(event.key)" [(ngModel)]="register.companyDocument" placeholder="{{i18n.HOME.COMPANY_DOCUMENT}}" value="{{register.companyDocument | cpfCnpj}}" maxlength="17" />
                    </div>
                    <div class="button-orange mt-4 clickable" (click)="registerUser()">
                        <div class="pt-1">
                            <p class="white pt-2 f-14-rb">{{i18n.HOME.CREATE}}</p>
                        </div>
                    </div>
                    <div class="mt-3">
                        <div class="text-center mt-1 clickable" [routerLink]="[ '/']">
                            <p class="f-11-os gray">{{i18n.HOME.HAVE_ACCOUNT}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>